import React from "react";
import { useParams } from "react-router-dom";
import { Construction } from "lucide-react";

export default function EnConstruccion() {
  const { key } = useParams();
  const title = (key || "").replace(/^z_/, "").replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return (
    <div className="max-w-3xl mx-auto py-24 text-center" data-testid="en-construccion">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-red-50 text-red-600 mb-5">
        <Construction className="w-8 h-8" />
      </div>
      <h1 className="font-display text-3xl font-extrabold text-slate-900">{title}</h1>
      <p className="text-slate-500 mt-3">Este reporte está en construcción. El diseño y la conexión de datos se agregarán próximamente.</p>
    </div>
  );
}
